import { createContext } from "react";
import type { G_FetchUserQuery, G_PlanStatus, G_ServicePlan, G_ViewableRating } from "~/lib/graphql";

export const AuthContext = createContext(
  {} as {
    /** ログイン状態 */
    isLoggedIn: boolean;
    /** プラットフォーム認証画面へのリダイレクト処理 */
    execAuth: () => void;
    /** Conversion API を発火させるリクエストパラメータ（open_id）で使用する */
    userId?: string;
    /** todo 開発環境でログイン状態を可視化するために利用。後で消す*/
    email?: string;
    /** ユーザーが利用しているサービスプラン, 未ログイン時はundefinedを返す */
    servicePlan?: G_ServicePlan;
    /** 保有ポイント */
    wallet?: G_FetchUserQuery["user"]["wallet"];
    /** FANZA TV Plus会員ならtrue */
    isAvailableTvPlus: boolean;
    /** 視聴レーティング制限 */
    viewableRating?: G_ViewableRating;
    /** 親プロフィールID */
    profileId?: string;
    /** ユーザーのプラン情報 */
    planStatus?: G_PlanStatus;
    /** アフィリエイトオーナーかどうか */
    isAffiliateOwner?: boolean;
    /**初回購読可能か,対象プランに初回購読可能な場合trueを返す*/
    isFirstSubscribe?: boolean;
  }
);
